export enum OfflineMessageFilter {
  WithoutOffline = 0,
  WithOffline = 1,
}
